import { z } from "zod";

/**
 * True only for absolute http(s) URLs. Rejects javascript:, data:, vbscript:,
 * relative paths, protocol-relative (//host) URLs, and anything the WHATWG URL
 * parser cannot parse. The parser strips tabs/newlines before parsing, so an
 * obfuscated scheme such as "java\tscript:" collapses to a scheme this
 * allowlist still rejects.
 */
export function isHttpUrl(value: unknown): value is string {
  if (typeof value !== "string") return false;
  let parsed: URL;
  try {
    parsed = new URL(value.trim());
  } catch {
    return false;
  }
  return parsed.protocol === "http:" || parsed.protocol === "https:";
}

/** External-link input (e.g. an issuance CTA): absolute http(s) URLs only. */
export const httpUrl = z
  .string()
  .trim()
  .refine(isHttpUrl, { message: "Enter a valid http(s) link" });
